
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getUserPreferences } from '../authService';
import { useAuth } from './AuthContext'; // ✅ Needed to detect login

const UserPreferencesContext = createContext();

export function UserPreferencesProvider({ children }) {
  const { authState } = useAuth(); // ✅ Access authState
  const [preferences, setPreferences] = useState(null);
  const [loading, setLoading] = useState(false);

  const validatePreferences = (prefs) => {
    const updated = { ...prefs };
    if (!updated.tracking_opt_in) {
      updated.show_growth_summary = false;
    }
    return updated;
  };

  // AuthContext owns the initial request. Mirror its result instead of issuing
  // a duplicate /api/preferences request after every successful login.
  useEffect(() => {
    if (authState.isAuthenticated) {
      setLoading(authState.prefsLoading);
      if (authState.preferences !== null) {
        setPreferences(validatePreferences(authState.preferences));
      }
    } else {
      setPreferences(null);
      setLoading(false);
    }
  }, [authState.isAuthenticated, authState.preferences, authState.prefsLoading]);

  const refreshPreferences = async () => {
    try {
      const prefs = await getUserPreferences();
      setPreferences(validatePreferences(prefs));
    } catch (err) {
      console.error('Failed to refresh user preferences:', err);
    }
  };

  return (
    <UserPreferencesContext.Provider value={{ preferences, refreshPreferences, setPreferences, loading }}>
      {children}
    </UserPreferencesContext.Provider>
  );
}

export function useUserPreferences() {
  return useContext(UserPreferencesContext);
}
